// Client-side constants that are not part of the frozen sim contract.

/** Corner feedback entry on the result page (design §4.4 / §15.3). */
export const FEEDBACK_URL = 'mailto:feedback@beatme.run?subject=Beat%20Me';

/** Slow-mo on a near miss: 0.5× for 20 sim frames (design §2.5). */
export const NEAR_MISS_SLOWMO_FRAMES = 20;
export const NEAR_MISS_TIMESCALE = 0.5;
/** Within 0.3 grid of a death box counts as "grazed it" (TECH_SPEC §4.1). */
export const NEAR_MISS_FQ = 307;

/** Overtake flash + floating text lifetime, in sim frames. */
export const FLOATING_TEXT_FRAMES = 78;
export const FLASH_FRAMES = 10;

/** Peak-arm overtake amplification (§4bis.22): ~1.5 s wall-clock, deliberately
 *  bigger and deeper than the near miss — beat hierarchy. Arm-gated. */
export const OVERTAKE_SLOWMO_FRAMES = 36;
export const OVERTAKE_TIMESCALE = 0.4;

/**
 * §4bis.30 — the 快斗 mid-run seal, fired on the frame the duel's line is
 * passed. Deeper than the overtake's 36 @ 0.4 (beat hierarchy: this is the
 * moment the duel was asking about) and shorter than the 60 frames between the
 * two beats, so the seal's slow-mo can never overlap the overtake's.
 *
 * The slow-mo is a gift and an honest one: it buys wall-clock reaction time
 * over exactly 42 sim frames, identically for everyone, while the sim advances
 * the same integer frames. Verification, the frame-based reaction check and
 * every visual baseline are untouched by it.
 */
export const DUEL_SEAL_SLOWMO_FRAMES = 42;
export const DUEL_SEAL_TIMESCALE = 0.35;
/** Stamp lifetime in wall-clock ms: punch-in 180 + hold 900 + fade 320. */
export const DUEL_SEAL_HOLD_MS = 1400;

/** Free newbie revive offer window, seconds (design §2.6). */
export const REVIVE_OFFER_SECONDS = 3;

// Frozen §2.3 geometry, re-exported from the sim so presentation (near-miss
// detection and drawing) can never drift from collision.
export { HITBOX_STAND_W, HITBOX_STAND_H, HITBOX_SLIDE_W, HITBOX_SLIDE_H } from '@beatme/sim';
export { SPIKE_H as SPIKE_TOP_FQ, BAR_BOTTOM as BAR_BOTTOM_FQ } from '@beatme/sim';
